import React from 'react'
import { EventsContainer } from 'containers'

const EventsPage = () => <EventsContainer />

export default EventsPage
